import { createDynamicThunk } from ".";

export const fetchSendFormsThunk = createDynamicThunk({
  typePrefix: "sendForms/fetchSendFormsThunk",
  endpoint: "/sendForms/findAll",
  method: "POST",
});

